<template>
    <rkm-row>
        <rkm-col cols="12">
            <rkm-form-textarea
                v-model="data.model.complemento"
                name="observacao"
                rows="4"
                max-rows="4"
                :validations="validations.complemento"
            >
            </rkm-form-textarea>
        </rkm-col>
    </rkm-row>
</template>

<script>
export default {
    computed: {
        validations() {

            return {
                complemento: { max: 1000 },
            }
        },
    },

    props: {
        data: { type: Object, required: false, },
    },
}
</script>